import React__default from 'react';
import { useStyles, useIsMobile } from '@sravni/react-utils';
import '../ContextProvider/components/IsOTPSendedProvider/provider.js';
import { useIsOTPSended } from '../ContextProvider/components/IsOTPSendedProvider/hook.js';
import { Form } from '../Form/view.js';
import { OTPScreen } from './components/OTPScreen/index.js';
import { PhoneScreen } from './components/PhoneScreen/index.js';
import modules_13b53a7e from './styles.module.less.js';

const AuthForm = React__default.forwardRef((props, ref) => {
    const { className = '', children, title = 'Вход и регистрация', subTitle = 'Введите ваш номер телефона. На него мы отправим СМС с кодом подтверждения', onGetOTPLinkClick, onGetOTPButtonClick, onChangePhoneClick, ...rest } = props;
    const cx = useStyles(modules_13b53a7e);
    const isMobile = useIsMobile();
    const [isOTPSended] = useIsOTPSended();
    return (React__default.createElement(Form, { enableAutoSubmit: !isMobile, ...rest, className: cx('form', className), ref: ref },
        isOTPSended ? (React__default.createElement(OTPScreen, { onGetOTPClick: onGetOTPLinkClick, onChangePhoneClick: onChangePhoneClick })) : (React__default.createElement(PhoneScreen, { title: title, subTitle: subTitle, onGetOTPClick: onGetOTPButtonClick })),
        children));
});

export { AuthForm };
//# sourceMappingURL=view.js.map
